<form class="tw-w-full tw-h-fit" [ngClass]="darkBackground ? 'tw-mb-6' : 'tw-mb-4'" [formGroup]="formGroup">
  <p class="tw-w-full tw-h-fit" [ngClass]="darkBackground ? 'tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2' : 'tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1'">
    {{ label | translate }} {{ isRequired || darkBackground ? "" : ("optional" | translate) }}
  </p>
  <ngx-intl-tel-input
    [cssClass]="'phone-input'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="true"
    [selectedCountryISO]="selectedCountryISO"
    [maxLength]="15"
    [phoneValidation]="true"
    [inputId]="'phone-input-id'"
    name="phone"
    formControlName="phone"
  ></ngx-intl-tel-input>
  <div *ngIf="darkBackground == false && formGroup.get(formControlName).invalid && formGroup.get(formControlName).dirty && formGroup.get(formControlName).touched">
    <small *ngIf="formGroup.get(formControlName).errors['required']" class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning">{{ "phone" | translate }} {{ "is-required" | translate }}</small>
    <small
      *ngIf="formGroup.get(formControlName).errors && formGroup.get(formControlName).errors['validatePhoneNumber'] && formGroup.get(formControlName).errors['validatePhoneNumber'].valid == false"
      class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning"
      >{{ label | translate }} {{ "is-not-valid" | translate }}</small
    >
  </div>
</form>
